import { useInstanceSettingsStore } from "#src/stores/instance-settings.js";

export function attachTagManager(pinia) {
  const instance = useInstanceSettingsStore(pinia);
  if (!instance.google_tag_manager_id) return;
  window.dataLayerGtag = window.dataLayerGtag || [];
  window.dataLayerGtag.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });
}
